import styles from "./EmployeePortfolioField.module.scss";
import { EmployeePortfolioEmployeeCard } from "./EmployeePortfolioEmployeeCard";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { ISelectFieldModel } from "../dropdown/models/selectFieldModel";

interface IEmployeePortfolioFieldProps {
  /** The persisted service id. Uploading is only possible once it exists. */
  serviceTypeId?: number;
  /** The employees currently selected for the service. */
  employees: ISelectFieldModel[];
  label?: string;
  subtitle?: string;
  notSavedHint?: string;
}

/**
 * A labelled form field that manages employee portfolios (one gallery per
 * employee) for a service. Styled to match the other form inputs.
 */
export const EmployeePortfolioField = ({
  serviceTypeId,
  employees,
  label = "Портфолио на служителите",
  subtitle = "Качете снимки на извършена работа за всеки служител. Клиентите ще ги виждат при избор на служител в портала.",
  notSavedHint = "Запазете услугата, за да добавите снимки в портфолиото на служителите.",
}: IEmployeePortfolioFieldProps) => {
  if (!employees || employees.length === 0) {
    return null;
  }

  const isPersisted = !!serviceTypeId && serviceTypeId > 0;

  return (
    <div className={styles.field}>
      <div className={styles.label}>{label}</div>
      <div className={styles.subtitle}>{subtitle}</div>

      <RenderWhen condition={!isPersisted}>
        <div className={styles.hint}>{notSavedHint}</div>
      </RenderWhen>

      <RenderWhen condition={isPersisted}>
        <div className={styles.cards}>
          {employees.map((employee) => (
            <EmployeePortfolioEmployeeCard
              key={employee.id}
              serviceTypeId={serviceTypeId}
              employeeId={employee.id}
              employeeName={employee.name}
            />
          ))}
        </div>
      </RenderWhen>
    </div>
  );
};
